<script>
import checkinItems from '@src/data/checkin-items.json'

export default {
  metaInfo: {
    title: 'View Checkin',
    meta: [{ name: 'description', content: 'View Checkin' }],
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      color: 'gold',
      checkinItems,
    }
  },
}
</script>

<template>
  <BaseView title="Check-in Details" :color="color">

    <VLayout row wrap>
      <!-- Checkin Items -->
      <VFlex v-bind="{ [checkinItems.size]: '' }" class="mb-4" xs12>
        <div class="title mb-2" :class="`--text`">
          {{ checkinItems.title }}
        </div>

        <BaseDisplayText
          v-for="listItem in checkinItems.items"
          :key="listItem.key"
          :label="listItem.label"
          :text="item[listItem.key]"
          class="mb-2"
        ></BaseDisplayText>

        <VLayout row wrap class="mb-4">
          <VFlex xs4>
            <VSubheader style="height: 25px;">Scan/Photo Of Passport/ID No</VSubheader>
          </VFlex>

          <VFlex xs8>
            <VImg v-if="item.identificationPhoto" :src="item.identificationPhoto"></VImg>
          </VFlex>
        </VLayout>

        <VLayout row wrap class="mb-2">
          <VFlex xs4>
            <VSubheader style="height: 25px;">Signature</VSubheader>
          </VFlex>

          <VFlex xs8>
            <div v-if="item.signature" class="grey lighten-3 pa-2" style="max-width: 150px;">
              <VImg :src="item.signature"></VImg>
            </div>
          </VFlex>
        </VLayout>
      </VFlex>

      <VFlex class="mb-4" xs12>
        <div class="title mb-2" :class="`--text`">
          Accompanying
        </div>
        <div
          v-for="(accompany, index) in item.accompanying"
          :key="`accompany-${index + 1}`"
          class="mb-2"
        >
          <BaseDisplayText
            :label="`Accompany ${index + 1} name`"
            :text="accompany.name"
          />

          <VLayout row wrap class="mb-4">
            <VFlex xs4>
              <VSubheader style="height: 25px;">Scan/Photo Of Passport/ID No</VSubheader>
            </VFlex>

            <VFlex xs8>
              <VImg :src="accompany.src"></VImg>
            </VFlex>
          </VLayout>
        </div>
      </VFlex>
    </VLayout>

    <template slot="card-actions-right">
      <VBtn :color="color" depressed dark :to="{ name: 'checkin' }">Back</VBtn>
    </template>
  </BaseView>
</template>
